import moment from 'moment'

const DATE_ONLY_FORMAT = 'YYYY-MM-DD'
const PREFERRED_HOURS = ['08:30', '10:00', '14:00', '16:00']

export const isToday = (date, days) => {
  const today = moment()
    .add(days, 'days')
    .format(DATE_ONLY_FORMAT)
  const selectedDate = moment(date).format(DATE_ONLY_FORMAT)

  return today === selectedDate
}

export const isOnThePast = (date) => {
  const today = moment().format(DATE_ONLY_FORMAT)
  const userDate = moment(date).format(DATE_ONLY_FORMAT)
  return today > userDate
}

export const generateCustomHours = (
  isToday,
  startTime,
  endTime,
  limitHours
) => {
  const currentHour = moment().format('HH:mm')

  let customHours = []

  for (let i = 0; i <= 1440; i += 15) {
    let hours = Math.floor(i / 60)
    let minutes = i % 60
    let hourMinute = null

    hours = hours % 24
    minutes < 10 ? (minutes = `0${minutes}`) : minutes
    hours < 10 ? (hours = `0${hours}`) : hours
    hourMinute = `${hours}:${minutes}`

    if (
      moment(hourMinute, 'hh:mm').isBetween(
        moment(isToday && limitHours ? currentHour : startTime, 'hh:mm'),
        moment(endTime, 'hh:mm')
      )
    ) {
      customHours.push(hours + ':' + minutes)
    }
  }

  return customHours
}

export const generatePreferredHours = (isToday, limitHours) => {
  const currentHour = parseInt(
    moment()
      .format('HH:mm')
      .replace(':', ''),
    10
  )

  const prefHours = PREFERRED_HOURS

  if (!isToday || !limitHours) return prefHours

  return prefHours.filter((hour) => {
    const parsedHour = parseInt(hour.replace(':', ''), 10)
    return parsedHour > currentHour ? hour : null
  })
}
